import { initBotId } from 'botid/client/core'

import { advisorBotIdOptions, advisorBotIdRoute } from './advisor-config'

initBotId({
  protect: [{ path: '/api/hearing-aids/guide-eligibility', method: 'POST', ...advisorBotIdOptions }, advisorBotIdRoute],
})
